import App from "@/app/App.tsx";
import { initPaginationStore } from "@/app/initPaginationStore";
import { initSidebarPreference } from "@/app/initSidebarPreference";
import { initToastAnalytics } from "@/app/initToastAnalytics";
import { initAnalytics } from "@/infrastructure/analytics";
import { initMonitoring } from "@/infrastructure/monitoring";
import { initVersionSkewWatch } from "@/infrastructure/versionSkew";
import "@/infrastructure/api/sdkConfig";
import "@/infrastructure/i18n/i18n";
import "@/styles/main.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Initialize Sentry monitoring FIRST (before React)
initMonitoring();
initAnalytics();
initToastAnalytics();
initPaginationStore();
initSidebarPreference();
initVersionSkewWatch();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
